import React, { useRef, useState } from 'react';
import { NavLink, Redirect } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { MuiThemeProvider } from "@material-ui/core/styles/";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../css/themeButtons";
import { login } from "./styles";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ForgotAccountContainer from "../common/ForgotAccount/ForgotAccountContainer";
import Box from "@material-ui/core/Box";


const Login = (props) => {
  const { userIsAuth, loginUser, updatedPass } = props
  const [showPassword, setShowPassword] = useState(false);


  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };


  const loginSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, 'Пароль не может быть короче 6 символов')
      .required('Поле не заполнено'),
    login: Yup.string()
      .required('Поле не заполнено'),
  });

  //реф формы
  const formRef = useRef()


  const validateActualityPassword = (message) => {
    if (formRef.current) {
      formRef.current.setFieldError('login', message)
      formRef.current.setFieldError('password', message)
    }
  }


  const onSubmit = async values => {
    let response = await loginUser(values)
    if (response) {
      validateActualityPassword(response)
    }
  }

  const buttons = themeButtons();
  if (userIsAuth) {
    return <Redirect to="/lk"/>
  }
  return (
    <div className="main ps-0">
      <div className="container-fluid">
        <div className="login">
          <div className="login-card mb-4">
            <Typography variant={"h4"} className={updatedPass ? "mb-2" : "mb-4"}>Вход</Typography>
            {updatedPass && <Box className="alert alert-success">
              Ваш пароль успешно обновлен! Войдите с новым паролем
            </Box>}

            <Formik validationSchema={loginSchema}
                    innerRef={formRef}
                    initialValues={{ login: '', password: '' }}
                    onSubmit={onSubmit}>
              {({ errors, touched }) => (
                <Form>
                  <div className="row">
                    <div className="col-12 mb-4">
                      <Field name="login">
                        {({ field, form }) => (
                          <TextField size="small"
                                     {...field}
                                     type="text" variant="outlined"
                                     className={"w-100"}
                                     autoComplete="off"
                                     label="Логин, указанный при регистрации"
                                     error={errors.login && touched.login}
                                     helperText={
                                       errors.login &&
                                       touched.login &&
                                       String(errors.login)
                                     }
                          />
                        )}
                      </Field>
                    </div>

                    <div className='col-12 mb-4'>
                      <Field name="password">
                        {({ field, form }) => (
                          <FormControl fullWidth size="small" variant="outlined"
                                       error={errors.password && touched.password}>
                            <InputLabel
                              htmlFor="outlined-adornment-password">Пароль</InputLabel>
                            <OutlinedInput
                              type={showPassword ? "text" : "password"}
                              {...field}
                              autoComplete="off"
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={toggleShowPassword}
                                    edge="end"
                                  >
                                    {showPassword ? <Visibility/> :
                                      <VisibilityOff/>}
                                  </IconButton>
                                </InputAdornment>
                              }
                              labelWidth={70}
                            />
                            {errors.password && touched.password
                              ?
                              <FormHelperText>{errors.password && touched.password && String(errors.password)}</FormHelperText>
                              : null}
                          </FormControl>

                        )}
                      </Field>

                      {/*{touched.login || touched.login ? <span>true</span> : <span>false</span>}   - строка для вывода ошибок лог/пасс  */}


                      <p className=" small text-end text-decoration-underline">
                        <Link component={NavLink} to="/lk/forgotpassword"
                              color="textSecondary">
                          Забыли
                          пароль?
                          Нажмите, чтобы восстановить
                        </Link>
                      </p>

                    </div>

                  </div>
                  <div className="row text-center justify-content-center">
                    <div className='col-auto mb-2'>
                      <Button type="submit"
                              className={`${buttons.btnGreen} px-5`}
                              variant="contained">Войти</Button>

                    </div>
                  </div>

                </Form>
              )}
            </Formik>

          </div>
        </div>
        <div className="login-card help-block">

          <Card raised={false}>
            <CardHeader title="Хочу добавить новый объект!"/>
            <CardContent className="">

              <div>Если вашего объекта нет на сайте</div>


            </CardContent>
            <CardActions className="d-flex justify-content-center mt-auto">
              <Button component={NavLink} variant="outlined" to="/lk/registration"
                      className={buttons.btnWarnOutline}>
                Регистрация
              </Button>
            </CardActions>
          </Card>

          <ForgotAccountContainer cardOrientation={"vertical"}/>
        </div>
      </div>
    </div>
  );


}

export default Login;
